import React, { Component } from 'react';
import { translate } from '../Services/translation';

class PageHeader extends Component {
    constructor(props) {
        super(props);
        this.textRef = React.createRef();

        this.state = {
            showButton: false,
            showMore: false,

        };
        this.toggle = this.toggle.bind(this);
    }

    componentDidMount() {
        let element = this.textRef.current;

        if (element && (element.offsetHeight < element.scrollHeight ||
            element.offsetWidth < element.scrollWidth)) {
            this.setState(() => ({
                showButton: true
            }));
        }
    }

    toggle() {
        this.setState(() => ({
            showMore: !this.state.showMore
        }));
    }

    render() {
        const props = this.props;

        return (  
            <>            
                {props.currentPageDescriptionEditor && props.currentPageDescriptionEditor.value ?
                    <div dangerouslySetInnerHTML={{ __html: props.currentPageDescriptionEditor.value }} style={{ color: props.textColor }} className={`main-image__description js-clamp ${this.state.showMore ? "" : "line-clamp"}`} ref={this.textRef} />
                    :
                    <p className={`main-image__description ${this.state.showMore ? "" : "line-clamp"}`} style={{ color: props.textColor }} ref={this.textRef}>
                        {props.currentPageDescription}
                    </p>
                }
                {this.state.showButton &&
                    <button className={this.state.showMore ? "main-image__show-less" : "main-image__show-more"} onClick={() => this.toggle()} style={{ color: props.textColor }}>{this.state.showMore ? translate('main.image.read.less') : translate('main.image.read.more')}
                        < svg className="arrow main-image__show-more-icon" style={{ fill: props.textColor }}>
                            <use href="/ui/images/tibergs-svg/sprite/sprite.svg#arrow-down"></use>
                        </svg>
                    </button>
                }            
            </>                                            
        );
    }
}

export default PageHeader;